module.exports = __webpack_public_path__ + "static/assets/b4e41c2ee2d01c10f3ce75f86c711fca.svg";